export const ICONS = {
  SHOW_MORE: "SHOW_MORE",
  ADD: "ADD",
  EDIT: "EDIT",
  DELETE: "DELETE",
};
